import BaseService from "../baseService";
import { IOptions } from "../../api-sdk";
import { AxiosResponse } from "axios";
import { IRecommendationsResponse } from "./recommendations.types";

class RecommendationsService extends BaseService {
    constructor(options: IOptions) {
        super(options);
    }

    /**
     * Fetch recommendation groups for the authenticated user.
     *
     * Calls `GET /api/v1/recommendations` and returns an array of recommendation groups.
     *
     * @returns Axios response whose `data` is `IRecommendationsResponse[]`.
     *
     * @example
     * const res = await zott.recommendations.getRecommendations();
     * console.log(res.data[0].title);
     */
    async getRecommendations(): Promise<AxiosResponse<IRecommendationsResponse[]>> {
        return this.request({
            method: "GET",
            url: "/api/v1/recommendations",
        });
    }
}

export default RecommendationsService;